
import React from 'react'

function ReceiptItemFooterStyle({signed_in}) {

  let edit_receipt_button_display = 'inline-block'
  let add_new_invoice_button_display = 'inline-block'
  if (signed_in !== 'admin') {
    edit_receipt_button_display = (signed_in.user_access.receipts_fc) ? 'inline-block' : 'none'
    add_new_invoice_button_display =(signed_in.user_access.invoice_fc && signed_in.user_access.invoice) ? 'inline-block' : 'none'
  }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .content-footer-container {
          /*background-color: pink;*/
          display: flex;
          font-size: 1rem;
          padding: 5px;
          justify-content: flex-end;
        }

        #edit-receipt-button { display: ${edit_receipt_button_display}; }
        #add-new-invoice-button { display: ${add_new_invoice_button_display}; }
      `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(ReceiptItemFooterStyle)
